import React, { useEffect } from "react";

const GoogleAds = ({ slot, layoutKey, adFormat = "fluid", fullWidthResponsive }) => {
  useEffect(() => {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{
        display: "block",
        textAlign: "center",
        ...(adFormat === "fluid"
          ? {
              minWidth: 250,
            }
          : {}),
      }}
      data-ad-layout="in-article"
      data-ad-format={adFormat}
      data-ad-client="ca-pub-9328641971758861"
      data-ad-slot={slot}
      data-ad-layout-key={layoutKey}
      data-full-width-responsive={fullWidthResponsive}
    ></ins>
  );
};

export default React.memo(GoogleAds);
